import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import {
  BLENDED_COLOR_JUNCTION_PATH,
  BLENDED_COLOR_PATH,
  BLENDED_WHITE_PATH,
} from './BlendedMarkIcon.paths'

type BlendedMarkIconProps = Omit<SvgIconProps, 'viewBox' | 'children'> & {
  /** Fill for both shuffle arrows. Defaults to white. */
  markColor?: string
}

/**
 * Compact Blended mark — both shuffle arrows in a single fill color.
 * Duplicated from packages/installable-kit CadencePicker until the kit is published.
 */
export const BlendedMarkIcon: React.FC<BlendedMarkIconProps> = ({
  markColor = '#F4F5F8',
  sx,
  ...props
}) => {
  return (
    <SvgIcon
      viewBox="0 0 100 100"
      aria-label="Blended"
      sx={{ display: 'block', ...sx }}
      {...props}
    >
      <path d={BLENDED_COLOR_PATH} fill={markColor} />
      <path d={BLENDED_COLOR_JUNCTION_PATH} fill={markColor} />
      <path d={BLENDED_WHITE_PATH} fill={markColor} />
    </SvgIcon>
  )
}
